<footer id="footerContainer">
    <div id="footerContent">
        <app-icons [icon]="dic.ICONS.torch"></app-icons>
        <div id="footerNav">
            <div id="footerLinks">
                <a [routerLink]="['/']">Home</a>
                <a [routerLink]="['/'+dic.STATES.games]">All Games</a>
                <a [routerLink]="['/'+dic.STATES.favourites]">Favourites</a>
                <a [routerLink]="['/'+dic.STATES.contactUs]">Contact Us</a>
                <a [routerLink]="['/'+dic.STATES.terms]">Terms & Conditions</a>
                <a [routerLink]="['/'+dic.STATES.blogs+'/top10']">Blogs</a>
                <a [routerLink]="['/'+dic.STATES.policy]">Policy</a>
            </div>

            <p class="text" id="footerText">
                Welcome to the world of DOS games! If you're feeling nostalgic and are looking for the best DOS games
                out there we have a wide collection of games for you to play & download for free!
                If you looking for DOS game and you can't find it here, then please contact us and we will do our best
                to find it for you.
                Stay tuned, new games are updated all the time!<br>
                We are using an awesome JavaScript library called <a href="https://js-dos.com/" rel="noopener" target="_blank">js-dos</a>.<br>
                All games are copyrighted by their respective owners.
            </p>

            <div id="copyright">
                <svg viewBox="0 0 16 16" height="15pt" width="15pt" id="copyrightIcon">
                    <path
                        d="M8 1.5c3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.5 6.5-6.5-2.9-6.5-6.5 2.9-6.5 6.5-6.5zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z">
                    </path>
                    <path
                        d="M9.9 10.3c-0.5 0.4-1.2 0.7-1.9 0.7-1.7 0-3-1.3-3-3s1.3-3 3-3c0.8 0 1.6 0.3 2.1 0.9l1.1-1.1c-0.8-0.8-2-1.3-3.2-1.3-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5c1.1 0 2-0.4 2.8-1l-0.9-1.2z">
                    </path>
                </svg>
                <p id="copyrightText">DOSGamesWorld.com 2023</p>
            </div>
        </div>
        <app-icons [icon]="dic.ICONS.torch"></app-icons>
    </div>
</footer>
